<div class="filter-section mb-3">
  <div class="filter-header" (click)="toggleExpand()">
    <h6 class="filter-title">
      {{ config.title }}
      <span class="filterTotal-count" *ngIf="selectedFiltersCount > 0">{{ selectedFiltersCount }}</span>
    </h6>
    <div class="filter-toggle">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" [class.expanded]="isExpanded">
        <path d="M4 6L8 10L12 6" stroke="#383838" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>
    <!-- Only show search if showSearch is true (defaults to true if not specified) -->
    <div class="searchContainer" *ngIf="isExpanded && config.showSearch">
      <app-common-search
        [placeholder]="'Search for ' + config.title.toLowerCase()"
        [(searchTerm)]="searchQuery"
        [minSearchLength]="1"
        [debounceTime]="500"
        (searchChange)="onSearchChange($event)"
        class="filter-accordion-search"
      ></app-common-search>
    </div>
  <div class="filter-content" [@expandCollapse]="isExpanded ? 'expanded' : 'collapsed'">
    <div *ngIf="config.type === 'checkbox' || config.type === 'radio'" class="checkbox-group">
      <div *ngFor="let option of visibleOptions" class="checkbox-item">
        <div class="checkbox-container">
          <input 
            type="{{ config.type === 'checkbox' ? 'checkbox' : 'radio' }}" 
            [id]="config.key + '-' + option.value" 
            [name]="config.key" 
            [value]="option.value" 
            [checked]="option.selected" 
            [disabled]="option.disabled"
            (change)="onOptionChange(option)" 
          />
          <label [for]="config.key + '-' + option.value" class="checkbox-label">
            <div class="label-content">
              <img *ngIf="option.icon && option.value !== 'all' && option.label.toLowerCase() !== 'all'" [src]="option.icon" alt="" class="option-icon" />
              <span>{{ option.label }}</span>&nbsp;
            </div>
            <span *ngIf="config.showCount !== false && option.count !== undefined && option.value !== 'all' && option.label.toLowerCase() !== 'all'" class="count">({{ option.count }})</span>
          </label>
        </div>
      </div>
      
      <!-- No results message -->
      <div *ngIf="hasSearched && searchQuery.length > 0 && filteredOptions.length === 0" class="no-results">
        <p>No results found for "{{ searchQuery }}"</p>
      </div>
    </div>

    <!-- Input Range Filter Type -->
    <div *ngIf="config.type === 'input-range'" class="range-input-container">
      <div class="range-inputs">
        <div class="input-group">
          <input 
            type="number" 
            [placeholder]="config.minPlaceholder || 'Min'" 
            [(ngModel)]="minValue" 
            (input)="onRangeInputChange()" 
            class="form-control"
          />
        </div>
        <div class="range-separator">to</div>
        <div class="input-group">
          <input 
            type="number" 
            [placeholder]="config.maxPlaceholder || 'Max'" 
            [(ngModel)]="maxValue" 
            (input)="onRangeInputChange()" 
            class="form-control"
          />
        </div>
      </div>
    </div>

    <!-- Slider Range Filter Type -->
    <div *ngIf="config.type === 'range'" class="range-slider-container">
      <input 
        type="range" 
        class="form-range" 
        [min]="config.minValue || 0" 
        [max]="config.maxValue || 100" 
        [step]="config.step || 1" 
        [(ngModel)]="sliderValue" 
        (input)="onSliderChange()"
      />
      <div class="range-values">
        <span>{{ config.minValue || 0 }}</span>
        <span>{{ config.maxValue || 100 }}</span>
      </div>
    </div>
  </div>
        <!-- View All/Less Button -->
        <div *ngIf="shouldShowViewAllButton" class="view-all-container">
          <span
             class="clear-filter text-decoration-none" 
             (click)="toggleViewAll($event)">
            {{ showAllOptions ? 'View Less' : 'View All' }}
          </span>
        </div>
</div> 